import $ from "jquery";
import { AimInfo, AimWarn } from "#scripts/tools/aimlog.js";
import { contentMeta, getDynDataOne } from "#scripts/general_functions";
import { findCategoryPaths } from "#scripts/nav";
import { decodeIfNeeded } from "#templates/pages/content";
import { getContactByEmail, setContactArticle } from "#scripts/contact_functions";
import { btiStep, btiLevel, btiClickActions } from "#scripts/bti";
import { campaignsFront, campaignsTheme } from "#src/templates/modules/campaigns";
import { newslistFront } from "#src/templates/modules/newslist";
import { cardsFront } from "#src/templates/modules/cardlisting";
import { calendarModule } from "#templates/modules/calendar";

export const compileResources = (content, all) => {
	const _content = document.createElement("div");
	_content.classList.add("article-parse");
	_content.insertAdjacentHTML("beforeend", content);
	const test = $(_content);

	let btiLevelInsert = 0;
	let btiStepInsert = 0;
	let html = "";

	const btiSteps = [];
	const btiLevels = [];

	// This code is required due to a bug in the API that does not remove h-card class/div after content replacement
	if (_content.querySelectorAll(".h-card > span#editorBlock").length > 0) {
		// unwrap only h-card containing editorBlock
		unwrapDiv(_content.querySelectorAll(".h-card > span#editorBlock"));
	}

	test.find("span#editorBlokk > span").each(function () {
		const id = $(this).attr("id") || false;
		const that = $(this);

		if (id) {
			$.each(all, (nr, obj) => {
				if (id === obj?.contentId) {
					if (obj.pageTypeId === "mal_blokk") {
						html = $(`<div class="blokk" data-id="${obj.contentId}" data-author="${obj.creator}">${decodeIfNeeded(obj.contentObject)}</div>`);

						if (obj.relatedContentObjects) {
							if (obj.relatedContentObjects.length > 0) {
								const testing = compileResources(html.html(), obj.relatedContentObjects);

								html.html(testing);
							}
						}
						if (obj.relatedContents.length > 0 && obj.relatedContentObjects === null) {
							console.info("[ Har relatedContents, men ikke følgeobject i relatedContentObjects ]");
							AimWarn("Item has relatedContents, but no corresponding object in relatedContentObjects", `ContentId: ${obj?.contentId}`);
						}
					} else if (obj.pageTypeId === "mal_visittkort" || obj.pageTypeId === "mal_dynamisk") {
						const meta = contentMeta(obj);
						meta.contentTypeId = meta.contentTypeId === undefined ? meta.id : meta.contentTypeId;

						//Changed to the line under;*/ if (testDynData(meta, "localId", "9c49f83a-bd49-425b-8fbb-6b211c038391")) { // Dynamisk mal kontaktkort.
						if (meta.contentTypeId === "18e51db9-304a-425f-afc0-d627a6fe9ef8") {
							// Dynamisk mal kontaktkort.
							let mail = getDynDataOne(meta, "9c49f83a-bd49-425b-8fbb-6b211c038391", "localId");
							if (mail) {
								// has mail.
								mail = mail.value;

								html = $(`<div class="blokk" data-id="${obj.contentId}" data-author="${obj.creator}">
                            <div class="spinner-border" role="status">
                              <span class="sr-only">Loading...</span>
                            </div></div>`);

								getContactByEmail(mail, (_data) => {
									const data = _data[0];
									let contact = "";
									if (data) {
										contact = setContactArticle({
											name: data.Name || false,
											email: data.Email || false,
											title: obj.title,
											phone: data.Mobile || false,
											// about: decodeURIComponent(obj.contentObject),
											about: obj.contentObject,
											// about: obj.contentObject,
											department: data.Subdivision || false,
										});
									}

									$(`.blokk[data-id='${obj.contentId}']`).html(contact);
								});
							}
						} else if (meta.contentTypeId === "aa33f116-bb07-4a93-9a27-12bc38d88efb") {
							// BTI-Nivå
							btiLevels.push({ obj, meta });
							if (btiLevelInsert < 1) {
								btiLevelInsert = 1;
								html = $(`<div class="blokk bti__header" data-group="aa33f116-bb07-4a93-9a27-12bc38d88efb" data-id="${obj.contentId}" data-author="${obj.creator}"></div>`);
							}
						} else if (meta.contentTypeId === "f63340c6-b3c3-49c0-b8c8-a661b55cd946") {
							// BTI-Trinn
							btiSteps.push({ obj, meta });
							if (btiStepInsert < 1) {
								btiStepInsert = 1;
								html = $(`<div class="blokk bti__content" data-group="f63340c6-b3c3-49c0-b8c8-a661b55cd946" data-id="${obj.contentId}" data-author="${obj.creator}"></div>`);
							}
						} else if (meta.contentTypeId === "c62f29ab-91e9-4aec-823a-80b4e0c99eef") {
							// BTI-Knapp
							// Dynamisk mal BTI - Knapp
							const link = getDynDataOne(meta, "10ec9d51-e156-44c1-9d20-f536e8323688", "localId").value;
							html = $(
								`<div class="blokk bti__button" data-id="${obj.contentId}" data-author="${obj.creator}"><div><a class="bti__button align-top" href="${link}"><h2>${obj.title}</h2><p>${obj.intro}</p></div>`,
							);
						} else if (meta.personNavn?.match(/^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/) ?? false) {
							html = $(`<div class="blokk" data-id="${obj.contentId}" data-author="${obj.creator}">
															<div class="spinner-border" role="status">
																<span class="sr-only">Loading...</span>
															</div></div>`);

							getContactByEmail(meta.personNavn, (_data) => {
								const data = _data[0];

								const contact = setContactArticle({
									name: data.Name || meta.personNavn || false,
									email: data.Email || meta.personEpost || false,
									title: meta.personStilling || false,
									phone: data.Mobile || meta.personMobil || false,
									about: meta.personFritekst || false,
									department: data.Subdivision || meta.personAvdeling || false,
								});

								$(`.blokk[data-id='${obj.contentId}']`).html(contact);
							});
						}
						else {
							const contact = setContactArticle({
								name: meta.personNavn || false,
								email: meta.personEpost || false,
								title: meta.personStilling || false,
								wiredPhone: meta.personTelefon || false,
								phone: meta.personMobil || false,
								about: meta.personFritekst || false,
								department: meta.personAvdeling || false,
								image: meta.imageContentId || false,
							});

							html = $(`<div class="blokk" data-id="${obj.contentId}" data-author="${obj.creator}">${contact}</div>`);
						}
					} else {
						that.parent().replaceWith("");
					}

					that.parent().replaceWith(html);
				}
			});

			const working = all?.filter((obj) => {
				return obj?.contentId === id ? obj : false;
			});

			if (working?.length < 1) {
				console.info(`[Has blokkcontent with Id but not content - removeing container: ${that.text()} ]`);
				that
					.parents(".h-card")
					.addClass("toberemoved")
					.prevUntil("h1,h2,h3,h4,h5,h6")
					.addBack()
					.prev("h1,h2,h3,h4,h5,h6")
					.addBack()
					.wrapAll("<div class='is_removed'><div class='removeable_group'></div></div>");
				AimInfo(`[Has blokkcontent with Id but not content - removeing container: ${that.parents(".h-card").text()} ]`);
				if (that.parents(".removeable_group").find(".h-card:not(.toberemoved)").length < 1) {
					that.parents(".removeable_group").remove();
				} else {
					that.parents(".removeable_group").find(".toberemoved").remove();
				}
			}
		}
	});

	test.find("span#editorBlokk > span[data-id=module]").each(function () {
		let id = $(this).attr("id") || false;
		if (id === "undefined") {
			id = false; // This check is due to a bug in the API that sometimes returns id="undefined"
		}
		const that = $(this);
		if (!id && this.dataset.id === "module") {
			const html = compileNewModule(that[0]);
			that.parent()[0].outerHTML = html;
		}
	});

	if (btiLevels.length > 0 && btiSteps.length > 0) {
		const levels = btiLevel(btiLevels);
		test.find('[data-group="aa33f116-bb07-4a93-9a27-12bc38d88efb"]').append(levels);
		const steps = btiStep(btiSteps, test);
		test.find('[data-group="f63340c6-b3c3-49c0-b8c8-a661b55cd946"]').append(`<div class="d-none d-sm-block bti__steps__container">${steps}</div>`);
	}

	btiClickActions();

	return test.html();
};

export const insertSegments = (content) => {
	const wrapper = $(`<div class='article-parse'><div class='pretest'><div class="article__group">${content}</div></div></div>`);

	wrapper.find(".pretest > h2, .pretest > h3").each(function () {
		$(this).addBack().nextUntil("h2,h3").addBack().wrapAll('<div class="article__group"></div>');
	});

	return wrapper.find(".pretest").html();
};

export const checkSingleLinks = (content) => {
	const wrapper = $(`<div class='article-parse'>${content}</div>`);

	wrapper.find("a.simple-button-plugin").removeAttr("style");
	wrapper.find("a.simple-button-plugin").each((i, elm) => {
		if (!elm.classList.contains("btn-secondary")) {
			elm?.classList.add("primary__button");
		}
	});
	wrapper.find("a.btn-primary").removeAttr("style");
	wrapper.find("a.btn-secondary").removeAttr("style");

	// Convert to relative URLs
	const aim = window.serverdata?.configMeta?.aim || {};
	const devHost = (() => { try { return aim.devUrl ? new URL(aim.devUrl).hostname : null; } catch { return null; } })();
	const redirectHost = (() => { try { return aim.status.redirectToURL ? new URL(aim.status.redirectToURL).hostname : null; } catch { return null; } })();
	const prodHost = window.location.hostname;

	wrapper.find('a[href]').each((_, elm) => {
		let u;
		try { u = new URL(elm.getAttribute('href'), document.baseURI); } catch { return; }

		if ((u.protocol === 'http:' || u.protocol === 'https:')
			&& ((devHost && u.hostname === devHost) || (prodHost && u.hostname === prodHost) || (redirectHost && u.hostname === redirectHost))) {
			elm.setAttribute('href', u.pathname + u.search + u.hash);
		}
	});
	return wrapper.html();
};

export const compileNewModule = (el) => {
	let moduleHtml = "";
	let maxItems = "";
	let moduleTitle = "";
	let moduleMoreText = "";
	let moduleCardDesign = "";
	const modulType = el.dataset.moduletype;
	switch (modulType) {
		case "kampanje": {
			maxItems = el.dataset?.campaignmaxnumber;
			// moduleCardDesign = el.dataset?.campaigndesign ?? "medium";
			moduleCardDesign = ["small", "medium", "large"].includes(el.dataset?.campaigndesign ?? "")
				? el.dataset.campaigndesign
				: "";
			const moduleCardImagePos = el.dataset?.imageposition ?? "left";
			const moduleCardItemGuid = el.dataset?.campaignids;
			const moduleCardColor = el.dataset?.bgcolor;
			const moduleCardButtontext = el.dataset?.campaignbuttontext ?? "";
			if (maxItems === undefined) {
				maxItems = moduleCardItemGuid.split(";").length;
			}
			// moduleHtml = campaignsFront(maxItems, moduleCardItemGuid, moduleCardDesign, moduleCardColor);
			moduleHtml = campaignsTheme(maxItems, moduleCardItemGuid, moduleCardDesign, moduleCardImagePos, moduleCardColor, moduleCardButtontext);
			break;
		}
		case "artikler": {
			maxItems = el.dataset?.articlesmaxnumber;
			moduleTitle = el.dataset?.articletitle;
			moduleCardDesign = el.dataset?.articledesign; // "card__design__1";
			const moduleCategory = el.dataset?.articlecatid;
			moduleMoreText = el.dataset?.articlealltitle;
			const moduleMoreLink = "";
			const moduleCardColor = el.dataset?.articlebgcolor;
			moduleHtml = cardsFront(moduleCategory, maxItems, moduleTitle, moduleMoreText, moduleMoreLink, moduleCardDesign, true, "sortByDate", moduleCardColor);
			break;
		}
		case "kategori": {
			maxItems = el.dataset?.articlesmaxnumber;
			moduleTitle = el.dataset?.articletitle;
			moduleCardDesign = el.dataset?.articledesign; // "card__design__1";
			const moduleCategory = el.dataset?.articlecatid;
			moduleMoreText = el.dataset?.articlealltitle;
			let categories = sessionStorage.getItem("aim-categories");
			categories = categories ? JSON.parse(categories) : [];
			const selectedCat = findCategoryPaths(categories, [moduleCategory]);
			const moduleMoreLink = '/nav/' + (selectedCat?.urlPath[selectedCat.urlPath.length - 1]);
			const moduleCardColor = el.dataset?.articlebgcolor;
			moduleHtml = cardsFront(moduleCategory, maxItems, moduleTitle, moduleMoreText, moduleMoreLink, moduleCardDesign, true, "sortByDate", moduleCardColor);
			break;
		}
		case "nyheter": {
			maxItems = el.dataset?.newsmaxnumber;
			moduleTitle = el.dataset?.newstitle;
			const moduleCategory = el.dataset?.categoryid;
			moduleMoreText = el.dataset?.newsalltitle;
			const moduleBgColor = el.dataset?.newsbgcolor;
			moduleHtml = newslistFront(moduleCategory, maxItems, moduleTitle, moduleMoreText, moduleBgColor);
			break;
		}
		case "kalender": {
			maxItems = el.dataset?.calmaxnumber;
			moduleTitle = el.dataset?.caltitle;
			const mode = window.serverdata.configMeta.aim?.calendar?.friskusId ? "friskus" : (window.serverdata.configMeta.aim?.calendar?.listMode ?? "");
			const calDesign = el.dataset.caldesign + (el.dataset.caldesign === "background" ? ':' + el.dataset.calbgcolor : ''); // background or normal (default)
			const moduleLinks = el.dataset?.callinks;
			const category = el.dataset?.calsubcat;
			moduleHtml = calendarModule(maxItems, moduleTitle, mode, moduleLinks, category, calDesign);
			break;
		}
	}
	return moduleHtml;
};

function unwrapDiv (div) {
	// Get the parent of the div
	const parent = div.parentNode;

	// Move all children out of the div
	while (div.firstChild) {
		parent.insertBefore(div.firstChild, div);
	}

	// Remove the now empty div
	parent.removeChild(div);
}
